import { useBridge } from "../BridgeContext";

export function useTare() {
  return useBridge().RNTareBridge;
}
